import moment from "moment";
import { TUserAttr } from "../User/User";
import { AppModel } from "../_Utils/AppModel";
import { Watchable } from "../_Utils/Watchable";
import { OrgMember } from "./OrgMember";
import { TDealerGroupAttr, TOrganizationAttr, TOrgInvitation, TOrgMemberAttr, TOrgRoleAttr } from "./Types";

export type DealerGroupEventMap = {
    ATTRIBUTES_UPDATED: TDealerGroupAttr;
    MEMBERS_UPDATED: OrgMember[];
    ORGANIZATIONS_UPDATED: { org: TOrganizationAttr; scopes: string[] }[];
    INVITATIONS_UPDATED: TOrgInvitation[];
    ORG_ROLES_UPDATED: TOrgRoleAttr[];
};

class DealerGroupData extends Watchable<DealerGroupEventMap> {
    constructor(attrs: TDealerGroupAttr) {
        super();
        this.cAttrs = attrs;
        this.attrs = attrs;
    }

    private cMembers: OrgMember[] = [];
    private cOrganizations: { org: TOrganizationAttr; scopes: string[] }[] = [];
    private cInvitations: TOrgInvitation[] = [];
    private cRoles: TOrgRoleAttr[] = [];
    private cAttrs: TDealerGroupAttr;

    set members(m: OrgMember[]) {
        this.cMembers = m;
        this.trigger("MEMBERS_UPDATED", m);
    }

    get members() {
        return this.cMembers;
    }

    set invitations(m: TOrgInvitation[]) {
        this.cInvitations = m;
        this.trigger("INVITATIONS_UPDATED", m);
    }

    get invitations() {
        return this.cInvitations;
    }

    set organizations(orgs: { org: TOrganizationAttr; scopes: string[] }[]) {
        this.cOrganizations = orgs;
        this.trigger("ORGANIZATIONS_UPDATED", orgs);
    }

    get organizations() {
        return this.cOrganizations;
    }

    set orgRoles(atr: TOrgRoleAttr[]) {
        this.cRoles = atr;
        this.trigger("ORG_ROLES_UPDATED", atr);
    }

    get orgRoles() {
        return this.cRoles;
    }

    set attrs(atr: TDealerGroupAttr) {
        atr.createdAt = moment(atr.createdAt);
        atr.updatedAt = moment(atr.updatedAt);
        this.cAttrs = atr;
        this.trigger("ATTRIBUTES_UPDATED", atr);
    }

    get attrs() {
        return this.cAttrs;
    }
}

export class DealerGroup extends AppModel<DealerGroupData> {
    public data: DealerGroupData;
    public readonly id: string;

    constructor(attributes: TDealerGroupAttr) {
        super();
        this.data = new DealerGroupData(attributes);
        this.id = attributes._id;
    }

    updateOrganizations(orgs: { org: TOrganizationAttr; scopes: string[] }[]) {
        this.data.organizations = orgs;
        return this;
    }
    addOrganization(org: { org: TOrganizationAttr; scopes: string[] }) {
        this.data.organizations = [...this.data.organizations, org];
        return this;
    }
    updateInvitations(invitations: TOrgInvitation[]) {
        this.data.invitations = invitations;
        return this;
    }
    updateRoles(roles: TOrgRoleAttr[]) {
        this.data.orgRoles = roles;
        return this;
    }
    updateMemberUserAttr(userData: TUserAttr) {
        this.data.members = this.data.members.map((m) => (m.attrs.user._id === userData._id ? m.updateMemberUserAttr(userData) : m));
        return this;
    }
    updateMembers(membersAttr: TOrgMemberAttr[]) {
        this.data.members = membersAttr.map((attr) => {
            const member = this.data.members.find((t) => t.id == attr._id);
            if (member) {
                return member.update(attr);
            } else return new OrgMember(attr);
        });
        return this;
    }
    updateAttributes(orgAttr: TOrganizationAttr) {
        this.data.attrs = { ...this.data.attrs, ...orgAttr };
        return this;
    }

    updateDealerGroup(org: DealerGroup) {
        this.data.attrs = org.data.attrs;
        return this;
    }

    getMember(userId: string): OrgMember | undefined {
        return this.data.members.find((t) => t.attrs.user._id === userId);
    }
}
